(() => {
  const selector = '[data-ava-next-products]';
  const gridSelector = '.collection-grid';
  const initialized = new WeakSet();

  function initialize() {
    for (const link of document.querySelectorAll(selector)) {
      if (initialized.has(link)) continue;
      initialized.add(link);
      const collection = link.closest('.collection');
      const grid = collection.querySelector(gridSelector);
      const status = collection.querySelector('[data-ava-load-status]');
      let loading = false;
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) load();
          }, { rootMargin: '300px' })
        : null;

      async function load() {
        if (loading || !link.isConnected) return;
        loading = true;
        observer?.unobserve(link);
        status.textContent = 'Loading more products.';
        const nextPage = new URL(link.href);
        nextPage.searchParams.set('section_id', grid.dataset.id);

        try {
          const response = await fetch(nextPage);
          if (!response.ok) throw new Error('Collection request failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = page.querySelector(gridSelector);
          if (!nextGrid?.children.length) throw new Error('Product grid missing');
          if (!link.isConnected) return;

          const knownCards = new Set(Array.from(grid.querySelectorAll('.card[id]'), card => card.id));
          const cards = Array.from(nextGrid.children).filter(item => {
            const card = item.querySelector('.card[id]');
            return card && !knownCards.has(card.id);
          });
          if (!cards.length) throw new Error('No new products');
          grid.append(...cards);
          status.textContent = cards.length + ' more products loaded.';
          const nextLink = page.querySelector(selector);
          if (nextLink) {
            link.href = nextLink.getAttribute('href');
            observer?.observe(link);
          } else {
            if (document.activeElement === link) {
              const firstNewLink = cards[0].querySelector('a[href]');
              firstNewLink?.focus({ preventScroll: true });
            }
            link.remove();
          }
        } catch {
          status.textContent = 'Could not load more products. Use the link to retry.';
        } finally {
          loading = false;
        }
      }

      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        load();
      });
      observer?.observe(link);
    }
  }

  initialize();
  const container = document.querySelector('.ava-catalog-main');
  if (container) new MutationObserver(initialize).observe(container, { childList: true, subtree: true });
})();
